/**
 * Шум Sentry в админке, который не является багом в нашем коде.
 * Паттерны выверены по реальным issue'ам (2023–2026).
 */
export const SENTRY_IGNORED_ERROR_PATTERNS: Array<RegExp> = [
  // WEB-1 (7651 событий, 152 пользователя, с 2023 года).
  // Axios кидает Cancel/Abort как отклонённый промис с undefined —
  // Sentry ловит их как "Non-Error promise rejection captured with value: undefined".
  // Это не баг, а нормальный сценарий отмены запроса при навигации.
  /Non-Error promise rejection captured with value: undefined/,

  // WEB-2Z / WEB-2Y: баг LightGallery — при быстром переключении slide=undefined.
  // Исправить можно только апгрейдом библиотеки, не наш код.
  /Cannot read properties of undefined \(reading '__slideVideoInfo'\)/,

  // Сетевые отмены на клиенте: пользователь закрыл вкладку / потерял сеть.
  // Для реальных серверных ошибок у нас есть 5xx-логи.
  /^Failed to fetch$/,
  /^Load failed$/,
  /NetworkError when attempting to fetch resource/,
  /The user aborted a request/,
  /^AbortError/,
  // WEB-4Q / WEB-5S: axios-таймаут с локализованным сообщением.
  // Суть — сетевая проблема на стороне клиента, не баг приложения.
  /Превышен таймаут/,
  /timeout of \d+ms exceeded/,
];

export function isIgnoredSentryMessage(message: unknown): boolean {
  if (typeof message !== 'string' || !message) return false;
  return SENTRY_IGNORED_ERROR_PATTERNS.some((p) => p.test(message));
}

export function sentryBeforeSend<
  E extends {
    message?: string;
    exception?: { values?: Array<{ value?: string }> };
  },
>(event: E, hint?: { originalException?: unknown }): E | null {
  const original = hint?.originalException;
  const originalMessage =
    original instanceof Error ? original.message : undefined;
  const eventMessage =
    event.message ?? event.exception?.values?.[0]?.value ?? undefined;

  if (
    isIgnoredSentryMessage(originalMessage) ||
    isIgnoredSentryMessage(eventMessage)
  ) {
    return null;
  }
  return event;
}
